<template>
	<div class="form-row m-0 p-0 nvdate">
		<div class="pl-0" :class="{'col-5': show_day, 'col-8': !show_day}">
			<select class="form-control custom-select" ref="month" :class="{'custom-select-sm': small}" @change="updateVModel();doChange();" v-model="month" :required="required">
				<option value="01">January</option>
				<option value="02">February</option>
				<option value="03">March</option>
				<option value="04">April</option>
				<option value="05">May</option>
				<option value="06">June</option>
				<option value="07">July</option>
				<option value="08">August</option>
				<option value="09">September</option>
				<option value="10">October</option>
				<option value="11">November</option>
				<option value="12">December</option>
			</select>
		</div>

		<div class="col-3" v-if="show_day">
			<input type="number" ref="day" class="form-control" placeholder="Day" :class="{'form-control-sm': small}" @change="updateVModel();doChange();" v-model="day" :min="min_day" :max="max_day" :required="required" />
		</div>

		<div class="col-4 pr-0">
			<input type="number" ref="year" class="form-control" placeholder="Year" :class="{'form-control-sm': small}" @change="updateVModel();doChange();" v-model="year" :min="min_year" :max="max_year" :required="required" />
		</div>
	</div>
</template>

<script>
	export default {
		name: 'nvDate',
		props:
		{
			"value": {required: true},
			"required": {type: Boolean, required: false, default: true},
			"show_day": {type: Boolean, required: false, default: true},
			"small": {type: Boolean, required: false, default: false},
			"min_date": {required: false, default: null},
			"max_date": {required: false, default: null},
			"onchange": {required: false, default: null}
		},
		model: {
			prop: 'value',
			event: 'input'
		},
		data: function()
		{
			return {
				date: null,
				month: null,
				day: null,
				year: null,
			}
		},
		mounted: function()
		{
			// Store a local copy of the values to avoid mutating the props.
			this.date = this.value;

			if(this.date == null)
			{
				var dt = new Date();
				dt.setHours(9);
				var m = dt.getMonth() + 1;
				var d = dt.getDate();

				if(m < 10)
				{
					m = "0" + m;
				}

				if(d < 10)
				{
					d = "0" + d;
				}

				this.month = String(m);
				this.day = String(d);
				this.year = String(new Date().getFullYear());

				// Update v-model with the newly formatted string.
				this.updateVModel();

				return null;
			}

			// If we're given a date object, convert it to a string.
			// Time is set to 9am to avoid timezone issues.
			if(typeof this.date == "object")
			{
				this.date.setHours(9);
				this.date = this.date.toISOString().substring(0, 10);
			}

			// Extract each part of the date string.
			this.year = this.date.substring(0, 4);
			this.month = this.date.substring(5, 7);
			this.day = this.date.substring(8, 10);

			if(!this.show_day)
			{
				this.day = 1;
			}

			// Update v-model with the newly formatted string.
			this.updateVModel();
		},
		computed: {
			min_day: function()
			{
				return 1;
			},
			max_day: function()
			{
				return this.days_in_month;
			},
			min_month: function()
			{
				return 1;
			},
			max_month: function()
			{
				return 12;
			},
			min_year: function()
			{
				if(this.min_date)
				{
					var dt = this.min_date;

					// If we're given a date object, convert it to a string.
					// Time is set to 9am to avoid timezone issues.
					if(typeof dt == "object")
					{
						dt.setHours(9);
						dt = dt.toISOString().substring(0, 10);
					}

					return dt.substring(0, 4);
				}

				return 1900;
			},
			max_year: function()
			{
				if(this.max_date)
				{
					var dt = this.max_date;

					// If we're given a date object, convert it to a string.
					// Time is set to 9am to avoid timezone issues.
					if(typeof dt == "object")
					{
						dt.setHours(9);
						dt = dt.toISOString().substring(0, 10);
					}

					return dt.substring(0, 4);
				}

				return null;
			},
			days_in_month: function()
			{
				var thirty = ["04", "06", "09", "11"];

				if(thirty.indexOf(this.month) != -1)
				{
					return 30;
				}
				else if(this.month == "02")
				{
					return (this.leap_year ? 29 : 28);
				}
				else
				{
					return 31;
				}
			},
			leap_year: function()
			{
				var by4 = (this.year % 4 == 0);
				var by100 = (this.year % 100 == 0);
				var by400 = (this.year % 400 == 0);

				// Evenly divisible by 4 but not evenly divisible by 100.
				if(by4 && !by100)
				{
					return true;
				}
				// Evenly divisible by 4, 100, and 400.
				else if(by4 && by100 && by400)
				{
					return true;
				}
				return false;
			}
		},
		methods: {
			updateVModel: function()
			{
				// If any value is invalid, the date is null.
				if(this.year == null || this.month == null || this.day == null)
				{
					return null;
				}

				// Get date pieces and format to YYYY-MM-DD.
				var y = Number(this.year);
				var m = Number(this.month);
				var d = Number(this.day);
				var value = null;
				var dt = null;

				if(m < 10)
				{
					m = "0" + m;
				}
				if(d < 10)
				{
					d = "0" + d;
				}

				value = String(y) + "-" + String(m) + "-" + String(d);

				if(this.min_date && value != null)
				{
					dt = this.min_date;

					// If we're given a date object, convert it to a string.
					// Time is set to 9am to avoid timezone issues.
					if(typeof dt == "object")
					{
						dt.setHours(9);
						dt = dt.toISOString().substring(0, 10);
					}

					if(value < dt)
					{
						try
						{
							this.$refs.month.setCustomValidity("Minimum date is " + dt + ".");
							this.$refs.month.reportValidity();
						}
						catch(e)
						{
							// setCustomValidity not supported, probably IE11.
						}
						value = null;
					}
				}

				if(this.max_date && value != null)
				{
					dt = this.max_date;

					// If we're given a date object, convert it to a string.
					// Time is set to 9am to avoid timezone issues.
					if(typeof dt == "object")
					{
						dt.setHours(9);
						dt = dt.toISOString().substring(0, 10);
					}

					if(value > dt)
					{
						try
						{
							this.$refs.month.setCustomValidity("Maximum date is " + dt + ".");
							this.$refs.month.reportValidity();
						}
						catch(e)
						{
							// setCustomValidity not supported, probably IE11.
						}
						value = null;
					}
				}

				if(value != null)
				{
					try
					{
						this.$refs.month.setCustomValidity("");
						// this.$refs.month.reportValidity();
					}
					catch(e)
					{
						// setCustomValidity not supported, probably IE11.
					}
				}

				// Emit the changed input value for v-model.
				this.$emit('input', value);
			},
			doChange: function()
			{
				if(typeof this.onchange == "function")
				{
					this.onchange();
				}
			}
		}
	}
</script>
